import React from 'react'
import { AuthorProfile } from '../Components/AuthorProfile/AuthorProfile'

export const AuthorProfilePage = () => {
  return (
    <div>
        <AuthorProfile/>
    </div>
  )
}
